module.exports = __webpack_public_path__ + "img/servicenode_img.c69c2d44.png";